export const selectedSection = {
  COLOR: 0,
  IMAGE: 1,
  CODE: 2,
  SOUND: 3,
};
